export default "__VITE_ASSET__KghyPkag__"